import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { SharedModule } from '../shared/shared.module';
import { LayoutModule } from '../shared/layout/layout.module';
import { CallHistoryListComponent } from './call-history-list/call-history-list.component';
import { CallHistoryComponent } from './call-history.component';
import { CallHistoryRoutingModule } from './call-history-routing.module';
import { CallHistoryEffects } from './call-history.effects';
import { callHistoryReducer } from './call-history.reducer';
import { CallHistoryService } from './call-history.service';
import { CallHistoryResolve } from './call-history.resolve';
import { MsisdnResolver } from '../shared/msisdn/msisdn.resolver';
import { UsersResolve } from '../phone-numbers/users/users.resolve';
import { ContactsModule } from '../contacts/contacts.module';
import { FormsModule } from '@angular/forms';
import { MatPaginatorIntl } from '@angular/material';
import { CustomPaginator } from './call-history-list/CustomPaginatorConfiguration';
import { DirectionFilterComponent } from './call-history-filters/direction-filter/direction-filter.component';
import { CallNumbersFilterComponent } from './call-history-filters/call-numbers-filter/call-numbers-filter.component';
import { UsersFilterComponent } from './call-history-filters/users-filter/users-filter.component';
import { AllMissedCallsFilterComponent } from './call-history-filters/all-missed-calls-filter/all-missed-calls-filter.component';
import { SearchFilterComponent } from './call-history-filters/search-filter/search-filter.component';
import { CallsTableComponent } from './call-history-list/calls-table/calls-table.component';
import { UsersSimplifiedResolve } from '../phone-numbers/users/usersSimplified.resolve';
import { HistoricalMsisdnResolver } from '../shared/msisdn/historical-msisdn.resolver';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    LayoutModule,
    TranslateModule,
    NgxPermissionsModule,
    CallHistoryRoutingModule,
    StoreModule.forFeature('callHistory', callHistoryReducer),
    EffectsModule.forFeature([CallHistoryEffects]),
    ContactsModule,
    FormsModule
  ],
  declarations: [
    CallHistoryListComponent,
    CallHistoryComponent,
    DirectionFilterComponent,
    CallNumbersFilterComponent,
    UsersFilterComponent,
    AllMissedCallsFilterComponent,
    SearchFilterComponent,
    CallsTableComponent
  ],
  providers: [
    CallHistoryService,
    CallHistoryResolve,
    MsisdnResolver,
    UsersResolve,
    UsersSimplifiedResolve,
    HistoricalMsisdnResolver,
    {
      provide: MatPaginatorIntl,
      useValue: CustomPaginator()
    }
  ]
})
export class CallHistoryModule {}
